module.exports = __webpack_public_path__ + "assets/09477c3273f6c737c7a9d066669ade54.mp3";